module.exports = __webpack_public_path__ + "img/html.acaa60d2.png";